import { getApplicationSettings } from 'owa-application-settings';
import { logCoreUsage } from 'owa-analytics/lib/api/logCoreUsage';
import { getModuleContextMailboxInfo } from 'owa-module-context-mailboxinfo';
import mailReadRouteHandler from './mailReadRouteHandler';
import type { MailReadRouteParameters } from './mailReadRouteHandler';

export default async function applinkMailReadRouteHandler(
    parameters: MailReadRouteParameters
): Promise<void> {
    const mailboxInfo = getModuleContextMailboxInfo(); // May differ from the mailbox info being passed into the route handler

    if (getApplicationSettings('PlatformType').isMonarch) {
        logCoreUsage('ApplinkMailReadRouteHandlerInitiated', mailboxInfo, {
            scenario: 'monarch',
        });

        return mailReadRouteHandler(parameters);
    }

    // If not in Monarch, redirect to deeplink for OWA.
    // Interim solution for users who have popouts blocked
    const { itemId, domain, account } = parameters;

    if (itemId) {
        logCoreUsage('ApplinkMailReadRouteHandlerInitiated', mailboxInfo, {
            scenario: 'owa-deeplink',
        });

        const encodedItemId = encodeURIComponent(itemId);

        if (domain && account) {
            window.location.replace(
                window.origin + `/mail/deeplink/read/account/${domain}/${account}/${encodedItemId}`
            );
            return;
        }

        window.location.replace(window.origin + '/mail/deeplink/read/' + encodedItemId);
    }
}
